export const MAX_FILES_AVAILABLE_TO_UPLOAD = 25
